import type { ProblemDetails } from '../types/workspace';

export class ApiError extends Error {
  constructor(public readonly problem: ProblemDetails) {
    // Some route errors use Fastify's { message } shape rather than { title }.
    // An empty Error.message was passed to save callbacks as falsy and could
    // therefore acknowledge a rejected write as successful.
    super(problem.title || (problem as ProblemDetails & { message?: string }).message || `Speichern fehlgeschlagen (HTTP ${problem.status}).`);
  }
}

export async function api<T>(url: string, init?: RequestInit): Promise<T> {
  const hasBody = init?.body !== undefined && init.body !== null;
  const bodyIsBinary = init?.body instanceof Blob || init?.body instanceof FormData || init?.body instanceof ArrayBuffer;
  const headers = new Headers(init?.headers);
  if (hasBody && !bodyIsBinary && !headers.has('Content-Type')) headers.set('Content-Type', 'application/json');
  if (!headers.has('Cache-Control')) headers.set('Cache-Control', 'no-store');
  const response = await fetch(url, {
    ...init,
    cache: init?.cache ?? 'no-store',
    headers: {
      Accept: 'application/json, application/problem+json',
      ...Object.fromEntries(headers.entries())
    }
  });
  if (!response.ok) {
    let problem: ProblemDetails;
    try {
      problem = await response.json() as ProblemDetails;
    } catch {
      problem = { title: `HTTP ${response.status}`, code: 'HTTP_ERROR', status: response.status };
    }
    throw new ApiError(problem);
  }
  if (response.status === 204) return undefined as T;
  return response.json() as Promise<T>;
}
